/**
 * Legends Types
 *
 * Type definitions for the Legends component that displays
 * color-coded status indicators.
 */

/**
 * Individual legend item
 */
export interface LegendItem {
  /** Display name for the legend */
  name: string;
  /** Background color (CSS color value) */
  color: string;

  /** Optional unique identifier */
  id?: string;
}

/**
 * Legends component props
 */
export interface LegendsProps {
  /** Array of legend items to display */
  legends?: LegendItem[];
  /** Layout direction */
  direction?: "row" | "column";
  /** Alignment of legend items */
  align?: "start" | "center" | "end";

  /** Additional CSS class names */
  className?: string;
  /** Test ID for automated testing */
  "data-testid"?: string;
}

/**
 * Default booking status legends
 */
export const DEFAULT_BOOKING_LEGENDS: LegendItem[] = [
  {
    id: "available",
    name: "Ledig",
    color: "var(--booking-available-bg)",
  },
  {
    id: "partial",
    name: "Delvis ledig",
    color: "var(--booking-partial-bg)",
  },
  {
    id: "booked",
    name: "Booka",
    color: "var(--booking-booked-bg)",
  },
  {
    id: "overbooked",
    name: "Overbooka",
    color: "var(--booking-overbooked-bg)",
  },
  {
    id: "absence",
    name: "Fravær",
    color: "var(--booking-absence-bg)",
  },
];
